/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_checkout_exit_confirm = /** @type {(inputs: {}) => string} */ () => {
	return `Jste si jisti, že chcete opustit tuto stránku? Budete muset projít kroky platby znovu.`
};

const da_checkout_exit_confirm = /** @type {(inputs: {}) => string} */ () => {
	return `Er du sikker på, at du vil forlade denne side? Du skal gennemgå betalingsprocessen igen.`
};

const de_checkout_exit_confirm = /** @type {(inputs: {}) => string} */ () => {
	return `Sind Sie sicher, dass Sie diese Seite verlassen möchten? Sie müssen den Bezahlvorgang erneut durchlaufen.`
};

const en_checkout_exit_confirm = /** @type {(inputs: {}) => string} */ () => {
	return `Are you sure you want to leave this page? You will have to go through the payment steps again.`
};

const es_checkout_exit_confirm = /** @type {(inputs: {}) => string} */ () => {
	return `¿Estás seguro de que quieres salir de esta página? Tendrás que volver a pasar por los pasos de pago.`
};

const fr_checkout_exit_confirm = /** @type {(inputs: {}) => string} */ () => {
	return `Êtes-vous sûr de vouloir quitter cette page ? Vous devrez repasser par les étapes de paiement.`
};

const hu_checkout_exit_confirm = /** @type {(inputs: {}) => string} */ () => {
	return `Biztosan ki akarsz lépni erről az oldalról? Újra végig kell menned a fizetési lépéseken.`
};

const it_checkout_exit_confirm = /** @type {(inputs: {}) => string} */ () => {
	return `Sei sicuro di voler lasciare questa pagina? Dovrai ripetere i passaggi di pagamento.`
};

const nl_checkout_exit_confirm = /** @type {(inputs: {}) => string} */ () => {
	return `Weet je zeker dat je deze pagina wilt verlaten? Je moet het betaalproces opnieuw doorlopen.`
};

const pl_checkout_exit_confirm = /** @type {(inputs: {}) => string} */ () => {
	return `Czy na pewno chcesz opuścić tę stronę? Będziesz musiał ponownie przejść przez proces płatności.`
};

const pt_checkout_exit_confirm = /** @type {(inputs: {}) => string} */ () => {
	return `Tem certeza de que deseja sair desta página? Você terá que refazer as etapas de pagamento.`
};

const sv_checkout_exit_confirm = /** @type {(inputs: {}) => string} */ () => {
	return `Är du säker på att du vill lämna denna sida? Du måste gå igenom betalningsstegen igen.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const checkout_exit_confirm = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.checkout_exit_confirm(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("checkout_exit_confirm", locale)
	if (locale === "cs") return cs_checkout_exit_confirm(inputs)
	if (locale === "da") return da_checkout_exit_confirm(inputs)
	if (locale === "de") return de_checkout_exit_confirm(inputs)
	if (locale === "en") return en_checkout_exit_confirm(inputs)
	if (locale === "es") return es_checkout_exit_confirm(inputs)
	if (locale === "fr") return fr_checkout_exit_confirm(inputs)
	if (locale === "hu") return hu_checkout_exit_confirm(inputs)
	if (locale === "it") return it_checkout_exit_confirm(inputs)
	if (locale === "nl") return nl_checkout_exit_confirm(inputs)
	if (locale === "pl") return pl_checkout_exit_confirm(inputs)
	if (locale === "pt") return pt_checkout_exit_confirm(inputs)
	return sv_checkout_exit_confirm(inputs)
};
export { checkout_exit_confirm as "checkout.exit_confirm" }